import { useQuery } from "@tanstack/react-query";

import { getBeefManureStorage, getBeefManureStorageAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE, FOOTPRINTING_BEEF_MANURE_STORAGE } from "consts";

import { UploadableBeefManureStorage } from "models";

export const useGetFootprintingBeefManureStorage = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<UploadableBeefManureStorage[]>({
    queryKey: [FOOTPRINTING_BEEF_MANURE_STORAGE, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getBeefManureStorageAdmin(primaryDataId) : getBeefManureStorage(primaryDataId)),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
